
import { Dialog, DialogContent, Typography } from "@mui/material";
import React, { useEffect } from 'react';
import { EEA2Service } from '../../../../Component/Api/EmploymentEquity/WorkforceProfile_EEA2/EEA2Service';
import { MDBox } from "../../../../Component/Common/Components/MDBox";
import { WorkforceProfileDto } from '../../../../Component/Model/Dto/EmploymentEquity/WorkforceProfile_EEA2/WorkforceProfile';
import { Gender, RaceTypes } from '../../../../Component/Model/Enum/BEE123Enums';
import { EEOccupationalLevel } from "../../../../Component/Model/Enum/EmploymentEquity";
import { CustomDialogTitle } from "../../../Common/Custom/CustomDialogTitle";
import { SkillsDevelopmentDrilldown } from "./SkillsDevelopmentDrilldown";
import { HeadcountSummaryTable } from "../../../../Component/Common/Components/Table/HeadcountSummaryTable";
import { SkeletonLoading } from "../../../../Component/Common/SkeletonLoading/SkeletonLoading";

interface IProps {
    scorecardId: string;
}

export const SkillsDevelopment = (props: IProps) => {

    const [allEmployeeData, setAllEmployeeData] = React.useState<WorkforceProfileDto.SummarySectionDto[]>([]);
    const [showDrillDown, setShowDrillDown] = React.useState<boolean>(false);
    const [isPermanent, setIsPermanent] = React.useState<boolean>();
    const [occupationalLevel, setOccupationalLevel] = React.useState<EEOccupationalLevel>();
    const [race, setRace] = React.useState<RaceTypes>();
    const [gender, setGender] = React.useState<Gender>();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            let searchResult = await EEA2Service.GetSkillsDevelopmentHeadcountSummary(props.scorecardId);
            setAllEmployeeData(searchResult.data)
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false);
        }
    };

    
    const onSegmentClick = (occupationalLevel?: EEOccupationalLevel, race?: RaceTypes, gender?: Gender, isPermanent?: boolean) => {
        setOccupationalLevel(occupationalLevel);
        setRace(race);
        setGender(gender);
        setShowDrillDown(true);
        setIsPermanent(isPermanent);
    }


    useEffect(() => {
        fetchData();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <MDBox mt={3} style={{ backgroundColor: "white", padding: "15px", paddingTop:"20px", paddingBottom:"10px"}}>
                {
                    (!isLoading && allEmployeeData.length > 0)
                    ? <HeadcountSummaryTable tableData={allEmployeeData} onSegmentClick={onSegmentClick}/>
                    : <SkeletonLoading tableLoading/>
                }
                <Typography variant='body1' sx={{ fontSize: "12px", paddingTop: "15px", color: '#4d4f53' }}>
                    Please note: Foreign Nationals are not included in the EEA report.
                </Typography>
            </MDBox>
            <Dialog open={showDrillDown} onClose={() => setShowDrillDown(false)} aria-labelledby="form-dialog-title" maxWidth='xl'>
                <CustomDialogTitle id="customized-dialog-title" onClose={() => setShowDrillDown(false)}>
                    Employee Structure
                </CustomDialogTitle>
                <DialogContent>
                    <SkillsDevelopmentDrilldown scorecardId={props.scorecardId} occupationId={occupationalLevel} raceId={race} genderId={gender} isPermanent={isPermanent} />
                </DialogContent>
            </Dialog>
        </>
    )
}
